import { useState } from "react";

export default function UsersPage({
  users,
  currentUser,
  roles = [],
  pages = [],
  addUser,
  updateUserRole,
  deleteUser,
  addRole,
  updateRole,
  removeRole
}) {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [editedUsers, setEditedUsers] = useState({});

  // Создание роли
  const [newRoleName, setNewRoleName] = useState("");
  const [newRolePages, setNewRolePages] = useState([]);
  // Локальные правки существующих ролей: { [roleId]: { name, pages } }
  const [editedRoles, setEditedRoles] = useState({});

  const createUser = () => {
    if (!name.trim() || !username.trim() || !password.trim() || !role) {
      return;
    }

    addUser(name.trim(), role, username.trim(), password);
    setName("");
    setUsername("");
    setPassword("");
    setRole("");
  };

  const updateEditedUser = (userId, field, value) => {
    setEditedUsers((current) => ({
      ...current,
      [userId]: {
        username: users.find((user) => user.id === userId)?.username || "",
        password: "",
        ...current[userId],
        [field]: value
      }
    }));
  };

  const saveCredentials = (user) => {
    const edited = editedUsers[user.id] || {};
    const nextUsername = edited.username ?? user.username;
    const nextPassword = edited.password ?? "";

    updateUserRole(user.id, user.role, nextUsername, nextPassword);
    setEditedUsers((current) => ({
      ...current,
      [user.id]: {
        username: nextUsername,
        password: ""
      }
    }));
  };

  const toggleNewRolePage = (key, checked) => {
    setNewRolePages((current) =>
      checked ? [...new Set([...current, key])] : current.filter((item) => item !== key)
    );
  };

  const createRole = () => {
    if (!newRoleName.trim()) {
      return;
    }

    addRole(newRoleName.trim(), newRolePages);
    setNewRoleName("");
    setNewRolePages([]);
  };

  const getEditedRole = (role) => editedRoles[role.id] || { name: role.name, pages: role.pages || [] };

  const updateEditedRole = (roleId, patch) => {
    setEditedRoles((current) => {
      const base = current[roleId] ||
        (() => {
          const found = roles.find((item) => item.id === roleId);
          return { name: found?.name || "", pages: found?.pages || [] };
        })();

      return { ...current, [roleId]: { ...base, ...patch } };
    });
  };

  const toggleEditedRolePage = (roleId, key, checked) => {
    const current = getEditedRole(roles.find((item) => item.id === roleId));
    const nextPages = checked
      ? [...new Set([...current.pages, key])]
      : current.pages.filter((item) => item !== key);

    updateEditedRole(roleId, { pages: nextPages });
  };

  const saveRole = (role) => {
    const edited = getEditedRole(role);

    if (!edited.name.trim()) {
      return;
    }

    updateRole(role.id, edited.name.trim(), edited.pages);
    setEditedRoles((current) => {
      const next = { ...current };
      delete next[role.id];
      return next;
    });
  };

  return (
    <div>
      <h1>Пользователи и роли</h1>

      <div className="roles-section">
        <h2>Роли</h2>
        <p>Создайте роль и отметьте, какие страницы видны её пользователям.</p>

        <div className="role-create">
          <input
            value={newRoleName}
            onChange={(e) => setNewRoleName(e.target.value)}
            placeholder="Название роли"
          />

          <div className="role-pages-grid">
            {pages.map((page) => (
              <label className="role-page-option" key={page.key}>
                <input
                  type="checkbox"
                  checked={newRolePages.includes(page.key)}
                  onChange={(e) => toggleNewRolePage(page.key, e.target.checked)}
                />
                <span>{page.label}</span>
              </label>
            ))}
          </div>

          <button onClick={createRole}>Создать роль</button>
        </div>

        <div className="roles-list">
          {roles.map((roleItem) => {
            const edited = getEditedRole(roleItem);

            return (
              <div className="role-row" key={roleItem.id}>
                <input
                  value={edited.name}
                  onChange={(e) => updateEditedRole(roleItem.id, { name: e.target.value })}
                  placeholder="Название роли"
                />

                <div className="role-pages-grid">
                  {pages.map((page) => (
                    <label className="role-page-option" key={page.key}>
                      <input
                        type="checkbox"
                        checked={edited.pages.includes(page.key)}
                        onChange={(e) => toggleEditedRolePage(roleItem.id, page.key, e.target.checked)}
                      />
                      <span>{page.label}</span>
                    </label>
                  ))}
                </div>

                <div className="role-row-actions">
                  <button onClick={() => saveRole(roleItem)}>Сохранить</button>
                  <button className="user-delete-btn" onClick={() => removeRole(roleItem.id)}>
                    Удалить
                  </button>
                </div>
              </div>
            );
          })}

          {roles.length === 0 && (
            <div className="roles-empty">Роли ещё не созданы.</div>
          )}
        </div>
      </div>

      <h2>Пользователи</h2>

      {roles.length === 0 ? (
        <p className="users-hint">Сначала создайте хотя бы одну роль, чтобы добавлять пользователей.</p>
      ) : (
        <div className="users-create">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Имя пользователя"
          />

          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
          />

          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
          />

          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="">Выберите роль</option>
            {roles.map((item) => (
              <option key={item.id} value={item.name}>{item.name}</option>
            ))}
          </select>

          <button onClick={createUser}>Создать пользователя</button>
        </div>
      )}

      <div className="users-list">
        {users.map((user) => (
          <div className="user-row" key={user.id}>
            <div className="user-title">
              <strong>{user.name}</strong>
              <span>{user.username || "username не задан"}</span>
            </div>

            <input
              value={editedUsers[user.id]?.username ?? user.username ?? ""}
              onChange={(e) => updateEditedUser(user.id, "username", e.target.value)}
              placeholder="Username"
            />

            <input
              value={editedUsers[user.id]?.password ?? ""}
              onChange={(e) => updateEditedUser(user.id, "password", e.target.value)}
              placeholder="Новый пароль"
              type="password"
            />

            {user.role === "ADMIN" ? (
              <span className="user-role-static">Админ</span>
            ) : (
              <select
                value={user.role}
                onChange={(e) => updateUserRole(user.id, e.target.value)}
              >
                {!roles.some((item) => item.name === user.role) && (
                  <option value={user.role}>{user.role_label || user.role}</option>
                )}
                {roles.map((item) => (
                  <option key={item.id} value={item.name}>{item.name}</option>
                ))}
              </select>
            )}

            <button onClick={() => saveCredentials(user)}>
              Сохранить
            </button>

            <button
              className="user-delete-btn"
              disabled={user.id === currentUser?.id}
              title={user.id === currentUser?.id ? "Нельзя удалить текущего пользователя" : "Удалить пользователя"}
              onClick={() => deleteUser(user.id)}
            >
              &#128465;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
